import React from "react"
import FieldDateRange from "../../../../generic/datetime/date-range/date-range"

import FieldConfig from "../../../../proto/field-config"
import Project from "../../../../../model2/project/project"
import ItemModelV2 from "../../../../../model2/item2/item-model"
import TasksViewManager from "../../../../../gd-modules/tasks-view/core/manager"
import {ViewType} from "../../../../../gd/const/views/view-type"
import GanttManager from "../../../../../gd-modules/gantt-chart/manager/manager"
import FieldProto_updateView from "../../../../proto/render/table/function/update-view"


export default class FieldProjectStartEnd extends FieldDateRange {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Start/End";
        this.icon               = 'i5-calendar';
        this.label              = _.get(config, 'label', "Project Start-End")

        this.components.ValueIcon   = <span className="ui5-ico-16 m-r-10 fl-no-shrink i5-calendar" />

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
        this.clearButton = _.get(config, 'clearButton', false);
    }

    canEdit(model: Project): boolean {
        return model.acl.canChangeStartDate
    }


    tableCellOnValueChange = async (item: ItemModelV2, value: MomentRange|null, manager: TasksViewManager|GanttManager) => {

        switch (manager.module) {
            case ViewType.PROJECT_GANTT:
            case ViewType.PORTFOLIO_GANTT:
            case ViewType.CUSTOM_VIEW_GANTT:

                const newStartDate  = value ? value.start : null
                const newEndDate    = value ? value.end : null

                const ganttManager = manager as GanttManager
                ganttManager.setStartEnd(item.id, newStartDate, newEndDate)

                break

            default:
                if (!value) {
                    // jsut start is enough
                    item.task.updateStartDate(null)
                } else {
                    item.task.updateStartDate(value.start)
                    item.task.updateEndDate(value.end)
                }

                item.project.save()

                item.updateLastUpdateTime() // otherwise it wont re-render

                FieldProto_updateView(manager as TasksViewManager, this)
                break
        }

    }

}
